import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postMatchmakerInviteCandidate,
  type PostMatchmakerInviteCandidateParams,
  type PostMatchmakerInviteCandidateResponse,
} from '@services/MatchmakerService';

export type UsePostMatchmakerInviteCandidateParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostMatchmakerInviteCandidateResponse,
    unknown,
    string,
    PostMatchmakerInviteCandidateParams,
    PostMatchmakerInviteCandidateResponse
  >;
};

export const postMatchmakerInviteCandidateMutationKey =
  'post-matchmaker-invite-candidate';

export const usePostMatchmakerInviteCandidate = ({
  mutationOptions,
}: UsePostMatchmakerInviteCandidateParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostMatchmakerInviteCandidateResponse,
    unknown,
    string,
    PostMatchmakerInviteCandidateParams
  >(
    postMatchmakerInviteCandidateMutationKey,
    (_url, { arg }) => postMatchmakerInviteCandidate(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
